import { useEffect } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { Flex } from "@similarweb/ui-components/foundations";

import { useToasts } from "app/common/hooks";
import { useTranslation } from "pro-features/components/WithTranslation";

export const useDurationChangedToastMessage = (isDurationChanged?: boolean) => {
    const translate = useTranslation();
    const { showErrorToast } = useToasts();

    useEffect(() => {
        if (isDurationChanged) {
            showErrorToast(
                <Flex
                    gap="8px"
                    alignItems="center"
                >
                    <SWReactIcons
                        iconName="error-info"
                        size="sm"
                    />
                    {translate("bt.report.filters.duration.duration-modified-toast.text")}
                </Flex>,
            );
        }
    }, [isDurationChanged, showErrorToast, translate]);
};
